import { render, staticRenderFns } from "./FilterExpenseCategoryWrapper.vue?vue&type=template&id=572c62e0"
import script from "./FilterExpenseCategoryWrapper.vue?vue&type=script&lang=js"
export * from "./FilterExpenseCategoryWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports